import moment from "moment";
import UserRoleEnum from "../constants/UserRoleEnum";
import { hasAccessRole } from "./utils";

export function showPendingContentBtn({editCampaignActive, currentCampaign, creationType, user}) {

    const currentDate = moment()
    const startDate = moment(currentCampaign.start_date)
    const showStatus = currentCampaign.status === 'pending' || currentCampaign.status === 'proposal'
    const isNext = currentCampaign.status === 'ready' && startDate >= currentDate
    const enabledRoles = hasAccessRole(user.roles, [UserRoleEnum.superAdmin, UserRoleEnum.superModeratorAgency, UserRoleEnum.superModeratorMediaCompany])
    
  return enabledRoles && ((!editCampaignActive && creationType !== 'makeProposal') || (editCampaignActive && showStatus) || (editCampaignActive && isNext))
}

export function isProposalCampaign({editCampaignActive, currentCampaign, creationType}) {

    return (editCampaignActive && currentCampaign.status === "proposal") || (!editCampaignActive && creationType === "makeProposal")
}

export function checkIsNewDisplayInEdit(displayId, initialBackup, hasInitialBackup) {
    if (!hasInitialBackup || !initialBackup || !initialBackup.cart) return false;
    return !initialBackup.cart.some(item => item.id === displayId);
}

export function isApprovedPaymentStatus(campaign) {
    return !!(campaign && campaign.payment_status === "approved");
}

export function isRemoveDisabledInApproved({
    paymentStatus,
    editCampaignActive,
    onCart,
    displayId,
    initialBackup,
    hasInitialBackup,
}) {
    if (!editCampaignActive || !onCart || paymentStatus !== "approved") return false;
    return !checkIsNewDisplayInEdit(displayId, initialBackup, hasInitialBackup);
}
